module.exports = __webpack_public_path__ + "static/media/hub_bigHeader.da8a411a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/hub_bigHeader.png
// module id = 460
// module chunks = 0